export const generalIntl = {
  headline: {
    en: "Leadership Assessment",
    dk: "Lederskab Evaluering"
  },
  headline_ta: {
    en: "Transactional Analysis",
    dk: "Transactional Analysis"
  },
  subheadline: {
    en: "Self- and 360°",
    dk: "Selv – og 360°"
  },
  subheadline_ta: {
    en: "",
    dk: ""
  },

  headText: {
    dk:
      "Du har nu udfyldt en selv-evaluering; en besvarelse af Institute of Leadership Dynamics A/S Leadelsesevaluering. Selve evalueringen bygger på de 71 spørgsmål du netop har besvaret. Disse er fordelt på 12 overordnede grupper eller parametre. De 12 parametre beskriver kvaliteter og egenskaber som er vigtige i rollen som leder - både i forbindelse med ledelse af andre og i konteksten af at lede sig selv.",
    en:
      "You have now completed a self-assessment. The assessment is based on the 71 questions you have just answered. These are divided into 12 parameters with 5 or 6 questions under each. The parameters describe qualities and attributes that are important in the role as leader - both in leading others and in the context of leading self."
  },
  headText_ta: {
    dk: "",
    en: ""
  },
  notificationHeader: {
    dk: "Tak fordi du udførte Transactional Analysis",
    en: "Thank you for filling Transactional Analysis"
  },

  notificationBody: {
    dk:
      "Nu har du yderligere mulighed for at evaluere din egen personlighed ved at udfylde drivers. Disse kan findes ved at logge ind igen på forsiden",

    en:
      "You may now evaluate yourself using the drivers evaluations. These can be found by logging in again on the front page."
  },

  introductionText: {
    dk:
      "Du har nu udfyldt en selv-evaluering; en besvarelse af Institute of Leadership Dynamics A/S Leadelsesevaluering. Selve evalueringen bygger på de 71 spørgsmål du netop har besvaret. Disse er fordelt på 12 overordnede grupper eller parametre. De 12 parametre beskriver kvaliteter og egenskaber som er vigtige i rollen som leder - både i forbindelse med ledelse af andre og i konteksten af at lede sig selv.",
    en:
      "You have now completed a self-assessment. The assessment is based on the 71 questions you have just answered. These are divided into 12 parameters with 5 or 6 questions under each. The parameters describe qualities and attributes that are important in the role as leader - both in leading others and in the context of leading self."
  },

  clipBoardText: {
    dk: "Klik for at kopiere link",
    en: "Click link to copy to clipboard"
  },

  invitationButtontext: {
    dk: "Send invitation to peer",
    en: "Send invitation til fagfælle"
  },

  downloadAllButtonText: {
    en: "Download all results",
    dk: "Download alle resultater"
  },
  donwloadOwnButtonText: {
    en: "Download own results",
    dk: "Download egne resultater"
  }
};



// WEBPACK FOOTER //
// ./src/pages/SurveyResults/generalIntl.js